export default __webpack_public_path__ + "static/media/venture-hero-bcg.e7a263e0.jpg";